//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
    DialogAddOnSaleGoods: () => import('./components/DialogAddOnSaleGoods/index.vue'),
    DialogDealer: () => import('../../../../components/DialogDealer/index.vue')
  },
  props: {
    tab: {
      default: ''
    },
    tableData: {
      default: () => []
    },
    pageData: {
      default: () => ({})
    },
    searchData: {
      default: () => ({})
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      addDialogVisible: false,
      dealerDialogVisible: false
    }
  },
  computed: {
    toQuery (){
      return {
        tab: this.tab,
        pageData: JSON.stringify(this.pageData),
        searchData: JSON.stringify(this.searchData)
      }
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleUpdatePrice:  function(row) {
      let data = _.pick(row.data, 'goodsId', 'price')
      console.log('data', data)
      this.$axios.post('/mtea/store/admin/goods/update/price', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    },
    handleUnpublish: function (row) {
      let data = _.pick(row.data, 'goodsId')
      // console.log('data', data)
      this.$axios.post('/mtea/store/admin/goods/unpublish', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    },
    cashBackMoney: function (row) {
      let data = _.pick(row.data, 'goodsId', 'cashBackMoney')
      data.cashMoney = data.cashBackMoney
      delete data.cashBackMoney
      this.$axios.post('/mtea/store/admin/goods/update/cashMoney', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    },
  }
}
